import { CopyAllOutlined } from "@mui/icons-material";
import "./go_with_calshare.scss";
import { useEffect, useState } from "react";

const PostDemo = () => {
  return (
    <div id="post">
      <div id="header">
        <div id="profile-pic"></div>
        <div id="username"></div>
      </div>
      <img
        src="../assets/go_with_calshare_post.png"
        alt="Visuel pour aller à un événement avec calshare en format publication instagram carré"
      />
      <div id="footer">
        <svg
          id="like"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 500 500"
        >
          <path
            d="M250,426.39l-72.21-63.18c0,0-179.83-136.17-104.07-250.84C134.67,20.12,250,121.51,250,121.51
          s115.33-101.4,176.28-9.14c75.76,114.67-104.07,250.84-104.07,250.84L250,426.39z"
          />
        </svg>
        <svg
          id="comment"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 500 500"
        >
          <path
            d="M400.32,342.33l21.24,77.34l-81.19-18.19c-26.43,15.81-57.32,24.91-90.35,24.91
          c-97.43,0-176.42-78.99-176.42-176.36c0-97.43,78.99-176.42,176.42-176.42c97.43,0,176.36,78.99,176.36,176.42
          C426.39,283.85,416.87,315.47,400.32,342.33z"
          />
        </svg>
        <svg
          id="share"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 500 500"
        >
          <polygon points="52.79,73.61 447.21,73.61 185.18,219.16 	" />
          <polygon points="447.21,73.61 241.1,426.39 185.18,219.16 	" />
        </svg>
        <svg
          id="save"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 500 500"
        >
          <polygon points="89.17,426.39 89.17,73.61 410.83,73.61 410.83,426.39 250,281.13 " />
        </svg>
      </div>
    </div>
  );
};

const StoryDemo = () => {
  return (
    <div id="story">
      <div id="header">
        <div id="progress-bar"></div>
        <div id="profile">
          <div id="profile-pic"></div>
          <div id="username"></div>
        </div>
      </div>
      <img
        src="../assets/go_with_calshare_story.png"
        alt="Visuel pour aller à un événement avec calshare en format story instagram portrait 9:16"
      />
      <div id="footer">
        <svg
          id="share"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 500 500"
        >
          <polygon points="52.79,73.61 447.21,73.61 185.18,219.16 	" />
          <polygon points="447.21,73.61 241.1,426.39 185.18,219.16 	" />
        </svg>
      </div>
    </div>
  );
};

interface ColorProps {
  colorHex: string;
  colorRgb: string;
}

const Color = ({ colorHex, colorRgb }: ColorProps) => {
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    if (clicked) {
      setTimeout(() => setClicked(false), 1000);
    }
  }, [clicked]);

  return (
    <div className="color">
      <div
        className="preview"
        style={{
          backgroundColor: colorHex,
        }}
      ></div>
      <p className="code">{colorHex}</p>
      <p className="code">{colorRgb}</p>
      <div
        className={`copy-icon ${clicked && "clicked"}`}
        onClick={() => {
          navigator.clipboard.writeText(colorHex);
          setClicked(true);
        }}
      >
        <CopyAllOutlined fontSize="large" />
      </div>
    </div>
  );
};

const sentences = [
  "😣 Pas de moyen de transport ? 🤩 Réserve ton trajet grâce à Calshare, l’app de covoiturage dédiée aux événements ! 🚗",
  "Pas de Calshare = Pas de trajet = Pas d’événement 🤷 (= Pas de rencontres)",
  "🚗 Remplis ta voiture et fais des économies/rencontres en utilisant Calshare 🤝",
  "Télécharge Calshare pour ne pas manquer l’événement ! 😎",
  "💰 Économise sur ton transport et rencontre d’autres pratiquants grâce à Calshare ! 🚗",
  "Économise sur tes frais, arrive directement sur place, fais des rencontres, utilises Calshare 😉🚗",
  "Pas d’argent ? 😕 Pas de panique, Calshare te permet quand même de venir à l’événement !!",
];

interface SentenceProps {
  text: string;
}

const Sentence = ({ text }: SentenceProps) => {
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    if (clicked) {
      setTimeout(() => setClicked(false), 1000);
    }
  }, [clicked]);

  return (
    <li className="sentence">
      <p>{text}</p>
      <div
        className={`copy-icon ${clicked && "clicked"}`}
        onClick={() => {
          navigator.clipboard.writeText(text);
          setClicked(true);
        }}
      >
        <CopyAllOutlined fontSize="large" />
      </div>
    </li>
  );
};

const GoWithCalshare = () => {
  return (
    <>
      <section className="part-page">
        <div id="main-word">
          <h2>
            Ne les laissez <span className="highlighted">pas galérer,</span>
          </h2>
          <h2>
            Indiquez <span className="highlighted">le chemin</span> à{" "}
            <span className="highlighted">vos athlètes !</span>
          </h2>
        </div>
      </section>
      <section id="visuals" className="full-page">
        <div className="visual-wrapper">
          <h3>Format post</h3>
          <p className="format-indicator">(1:1 carré)</p>
          <PostDemo />
          <a
            href="../assets/go_with_calshare_post.png"
            data-icon="💾"
            download="go_with_calshare_post"
            className="dl-button"
          >
            Télécharger le visuel
          </a>
        </div>
        <div className="visual-wrapper">
          <h3>Format story</h3>
          <p className="format-indicator">(9:16 portrait)</p>
          <StoryDemo />
          <a
            href="../assets/go_with_calshare_story.png"
            data-icon="💾"
            download="go_with_calshare_story"
            className="dl-button"
          >
            Télécharger le visuel
          </a>
        </div>
        <div className="visual-wrapper" id="calshare-logos-bundle">
          <h3>Logo Calshare</h3>
          <p className="format-indicator">(1:1 carré plein/transparent)</p>
          <div id="calshare-logos">
            <img src="../assets/calshare_s.svg" alt="Calshare round" />
            <img
              src="../assets/CALSHARE_logo_secondary_blanc.svg"
              alt="Calshare transparent white"
            />
            <img
              src="../assets/CALSHARE_logo_secondary_orange.svg"
              alt="Calshare transparent orange"
            />
          </div>
          <a
            href="../assets/calshare_logos_bundle.zip"
            data-icon="💾"
            download="calshare_logos_bundle"
            className="dl-button"
          >
            Télécharger le pack de logos
          </a>
        </div>
        <div className="visual-wrapper" id="calshare-colors">
          <h3>Couleurs Calshare</h3>
          <ul id="calshare-colors-list">
            <li>
              <Color colorHex="#fb6c0b" colorRgb="rgb(251, 109, 12)" />
            </li>
            <li>
              <Color colorHex="#ffffff" colorRgb="rgb(255, 255, 255)" />
            </li>
            <li>
              <Color colorHex="#bdbdbd" colorRgb="rgb(189, 189, 189)" />
            </li>
            <li>
              <Color colorHex="#131313" colorRgb="rgb(19, 19, 19)" />
            </li>
          </ul>
        </div>
        <div className="visual-wrapper" id="useful-sentences">
          <h3>Quelques phrases prêtes à copier/coller</h3>
          <p className="format-indicator">
            Pour vous économiser des ressources cérébrales (et surtout du temps)
            ;)
          </p>
          <ul id="calshare-sentences-list">
            {sentences.map((sentence, index) => (
              <Sentence key={`sentence-${index}`} text={sentence} />
            ))}
          </ul>
        </div>
      </section>
    </>
  );
};

export default GoWithCalshare;
